import { getJSONTagContent } from '@squareup/public-web-browser-helpers/meta-tag-helper';
/**
 * FeatureFlagImpl is a class that provides a way to access feature flags that are set in the meta tag sq:flags,
 * replacing window.Sq.Flags.
 */
class FeatureFlagImpl {
  flags: Record<string, unknown> = {};
  initialized: boolean = false;

  get(flag: string): unknown {
    if (!this.initialized) {
      this.init();
    }

    const value = this.flags[flag];
    if (value === undefined) {
      console.warn(
        `Flag ${flag} does not exist in sq:flags. Make sure it has been added to flag_config. Returning null instead.`
      );
      return null;
    }

    return value;
  }

  private init() {
    const [err, meta] = getJSONTagContent<Record<string, unknown>>('sq:flags');
    if (err !== null) {
      console.warn('sq:flags meta tag cannot be found or has invalid content.');
      return;
    }

    this.flags = meta;
    this.initialized = true;
  }
}

const featureFlagHelper = new FeatureFlagImpl();
export type FeatureFlag = typeof featureFlagHelper;
export default featureFlagHelper;
